import React from "react";
import { useRegistrationContext } from "../../Contexts/RegistrationContext";
import { AccordionItem } from "../../Elements/Accordion";
import { DrawType } from "../../Map/enums";
import { DrawingButton } from "./DrawingButton";
import { SketchProps } from "./SketchProps";

const allowedQuantity = 3;

export const DrawRoads = (): JSX.Element => {
    const { drawnFeatures } = useRegistrationContext();
    const noteFeatures = drawnFeatures.filter((f) => f.get("DRAWTYPE") === DrawType.PolylineRoad);
    const adddedFeatures = noteFeatures.length ? noteFeatures.length : 0;
    const title = `Pievešanas ceļš (${adddedFeatures}/${allowedQuantity})`;

    return (
        <AccordionItem
            title={title}
            changeHeight={Date.now()}
            defaultExpanded={noteFeatures.length}
            key="Pievešanas ceļš"
        >
            <div className="draw-toolbar">
                <DrawingButton
                    iconClass="icon-geo-polyline"
                    type={DrawType.PolylineRoad}
                    disabled={noteFeatures.length >= allowedQuantity}
                ></DrawingButton>
            </div>
            {noteFeatures &&
                noteFeatures.map((f) => <SketchProps feature={f} key={f.get("TEMPID") + "note"}></SketchProps>)}
        </AccordionItem>
    );
};
